import { useState } from 'react';
import { Bell, BellOff } from 'lucide-react';
import {
  chatNotifyPermission,
  chatNotifySupported,
  isChatNotifyEnabled,
  requestChatNotifyPermission,
  setChatNotifyEnabled,
} from '../lib/chatNotifications';

/**
 * Opt-in toggle for desktop notifications on PM chat replies (per browser,
 * default off). Hidden when the browser has no Notification API.
 */
export function ChatNotifyToggle() {
  const [enabled, setEnabled] = useState(isChatNotifyEnabled);
  const [permission, setPermission] = useState(chatNotifyPermission);

  if (!chatNotifySupported()) return null;

  const blocked = permission === 'denied';
  const on = enabled && permission === 'granted';

  const toggle = async () => {
    if (enabled) {
      setChatNotifyEnabled(false);
      setEnabled(false);
      return;
    }
    setChatNotifyEnabled(true);
    setEnabled(true);
    setPermission(await requestChatNotifyPermission());
  };

  return (
    <div className="flex items-center justify-end gap-2 text-xs text-ink-muted">
      {enabled && blocked && (
        <span>Notifications are blocked in your browser settings.</span>
      )}
      <label className="inline-flex cursor-pointer items-center gap-1.5">
        <input
          type="checkbox"
          className="h-3.5 w-3.5"
          checked={enabled}
          onChange={() => void toggle()}
        />
        {on ? <Bell className="h-3.5 w-3.5" aria-hidden /> : <BellOff className="h-3.5 w-3.5" aria-hidden />}
        Notify me when the PM replies
      </label>
    </div>
  );
}
